module.exports = __webpack_public_path__ + "img/home-grid-info-d-safe.0cb5f033.png";